/**
 * Языки ученика: список изучаемых, добавление, переключение активного и
 * язык интерфейса. Каждый ответ — полный список: стор обновляется им целиком.
 */

import type { LanguageCode, LanguagesView } from '@aptile/shared';

import { useLearningStore } from '../store/learningStore';
import { apiRequest, jsonBody } from './client';

function remember(view: LanguagesView): LanguagesView {
  useLearningStore.getState().setLanguages(view.activeLanguage, view.languages);
  return view;
}

export async function fetchLanguages(): Promise<LanguagesView> {
  return remember(await apiRequest<LanguagesView>('/api/languages'));
}

/** Новый изучаемый язык сразу становится активным. */
export async function addLanguage(language: LanguageCode): Promise<LanguagesView> {
  return remember(await apiRequest<LanguagesView>('/api/languages', { method: 'POST', body: jsonBody({ language }) }));
}

export async function switchLanguage(language: LanguageCode): Promise<LanguagesView> {
  return remember(await apiRequest<LanguagesView>('/api/languages/active', { method: 'PUT', body: jsonBody({ language }) }));
}

export async function saveUiLanguage(uiLanguage: LanguageCode): Promise<LanguagesView> {
  return remember(await apiRequest<LanguagesView>('/api/languages/ui', { method: 'PUT', body: jsonBody({ uiLanguage }) }));
}
